import { Routes } from '@angular/router';
import {LandingPageComponent} from "./landing-page/landing-page.component";
import {ReasonBoardComponent} from "./reason-utils/reason-board/reason-board.component"
import {ReasonComponent} from "./reason-utils/reason/reason.component";
import {CreateReasonComponent} from "./reason-utils/create-reason/create-reason.component";
import {SavedReasonsComponent} from "./reason-utils/saved-reasons/saved-reasons.component";
import {LoginComponent} from "./utils/login/login.component";
import {canActivate} from "./guards/auth.guard";
import {EditReasonComponent} from "./reason-utils/edit-reason/edit-reason.component";

export const routes: Routes = [
  { path: '', component: LandingPageComponent, canActivate: [canActivate]},
  { path: 'reason-board', component: ReasonBoardComponent, canActivate: [canActivate]},
  { path: 'reason/:id', component: ReasonComponent, canActivate: [canActivate]},
  { path: 'edit/:id', component: EditReasonComponent, canActivate: [canActivate]},
  { path: 'create', component: CreateReasonComponent, canActivate: [canActivate]},
  { path: 'saved', component: SavedReasonsComponent, canActivate: [canActivate]},
  { path: 'login', component: LoginComponent },
];
